module.exports = __webpack_public_path__ + "static/media/teamFour.1ca73b7c.webp";